import { useState } from 'react';

const persistedCache = {};

/**
 * The persisted state cache is meant to persist local component state through component dismounting. It is
 * not meant to be an alternate source of global state. It is not shared among different components and does not
 * trigger updates. It keeps a copy of state for components using this hook using a unique key to identify it
 * and retrieves it whenever that component remounts. The cache persists through the application's runtime, so it only
 * resets on page refresh.
 *
 * @param {string} key - a unique ID in the form {ComponentName}-{stateName} that preserves the state in the persistedCache
 * @param {all}    initial - the initial state that is set only when the component first mounts
 */

const usePersistedState = (key, initial) => {
  persistedCache[key] = persistedCache[key] || initial;
  const [state, setState] = useState(persistedCache[key]);
  return [
    state,
    value => {
      persistedCache[key] = value;
      setState(value);
    },
  ];
};

export default usePersistedState;
